module.exports = "/_next/static/images/b66b2b9ca7d047fe7b1328c32fd55957-nucommunity-lg@2x.jpg.webp";